import { render } from "./ContractReviewDetails.vue?vue&type=template&id=4d4b2d54"
import script from "./ContractReviewDetails.vue?vue&type=script&lang=js"
export * from "./ContractReviewDetails.vue?vue&type=script&lang=js"

import "./ContractReviewDetails.vue?vue&type=style&index=0&id=4d4b2d54&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__